module.exports = __webpack_public_path__ + "img/high-sell.d5a67e63.png";